import { reduxKey, FirstTimeFlag, FirstTimeFlagsType } from './constants';

export const getFirstTimeFlags = (state): FirstTimeFlagsType => {
  return state[reduxKey] || {};
};

export const hasFirstTimeFlag = (state, flag: FirstTimeFlag) => {
  return Boolean(getFirstTimeFlags(state)[flag]);
};
